import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { postSendSetlVerificationMessage } from "../../../../../API";
import { maskMobileNumber } from "../../../../../Functions/mask";
import { showToast } from "../../../../../utils/handleToast";
import useAuthStore from "../../../../../store/authStore";
import useBorrowerInfo from "../../store";

function SendVerificationMsg() {
    const userData = useAuthStore((state) => state.userData);
    const data = useBorrowerInfo((state) => state.data);

    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);

    const closeModal = () => {
        setShow(false);
        setLoading(false);
    };

    const sendVerification = async () => {
        if (!data?.data?.customer_mobile_number) {
            showToast({ variant: "warning", message: "Mobile number not found" });
            return;
        }

        if (!data?.data?.customer_id) {
            showToast({ variant: "warning", message: "Customer not found" });
            return;
        }

        setLoading(true);

        const res = await postSendSetlVerificationMessage({
            customer_id: data?.data?.customer_id,
            mobile_number: data?.data?.customer_mobile_number,
        });

        if (res) {
            showToast({ variant: "success", message: res?.message });
            closeModal();
        } else {
            showToast({ variant: "danger", message: "Failed to send" });
        }

        setLoading(false);
    };

    return (
        <>
            <a
                style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", color: "#118CEC" }}
                className="col-6 py-2 fw-medium"
                onClick={() => setShow(true)}
            >
                Send Verification Message
            </a>

            <Modal size="sm" show={show}>
                <Modal.Header>
                    <Modal.Title>Send Verification Message</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ minHeight: "10rem" }}>
                    <div className="py-5">
                        <p className="mb-1">Mobile Number</p>
                        <input
                            type="text"
                            value={!!userData?.remove_masking ? data?.data?.customer_mobile_number : maskMobileNumber(data?.data?.customer_mobile_number)}
                            readOnly
                            className="form-control"
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={closeModal}>
                        Close
                    </Button>
                    <Button disabled={loading} variant="primary" onClick={sendVerification}>
                        {loading ? "Sending..." : "Send"}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default SendVerificationMsg;
